/**
 * Build hideOnBreakpoint classes received from CMS
 *
 * @param hideOn
 */
export const buildHideCssClasses = (hideOn: string[]): string => {
	const hideClasses: string[] = [];

	hideOn.forEach((breakpoint) => {
		if (breakpoint === 'xs') {
			hideClasses.push('u-hide-xs-max');
		} else if (breakpoint === 'xl') {
			// As "xs" in the cms config starts at "0", we have
			// one fewer breakpoints coming from the CMS,
			// so we need to merge "lg" & "xl"
			hideClasses.push('u-hide-lg-min');
		} else {
			hideClasses.push(`u-hide-${breakpoint}-only`);
		}
	});

	return hideClasses.join(' ');
};
